import { Badge, Box, BoxProps, Stack, Text } from "@chakra-ui/react";
import React from "react";

/**
 * A callout box for a user 'Tip'.
 */
export function Callout({
  children,
  ...boxProps
}: {
  children: React.ReactNode;
} & Omit<BoxProps, "children">): React.ReactElement {
  const colorScheme = "blue";

  return (
    <Box
      backgroundColor={`${colorScheme}.50`}
      borderRadius="md"
      px={3}
      py={2}
      {...boxProps}
    >
      <Stack
        direction={{ base: "column", xs: "row" }}
        align="flex-start"
        spacing={2}
      >
        <Badge
          backgroundColor={`${colorScheme}.100`}
          color={`${colorScheme}.700`}
          borderRadius="full"
          px={2}
          py={0.5}
          flexShrink={0}
        >
          Tip
        </Badge>

        <Text fontSize="sm" color={`${colorScheme}.800`}>
          {children}
        </Text>
      </Stack>
    </Box>
  );
}
